import { render, staticRenderFns } from "./LoudMain.vue?vue&type=template&id=403334f7&scoped=true"
import script from "./LoudMain.vue?vue&type=script&lang=js"
export * from "./LoudMain.vue?vue&type=script&lang=js"
import style0 from "./LoudMain.vue?vue&type=style&index=0&id=403334f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403334f7",
  null
  
)

export default component.exports